class CollectionsSlide extends HTMLElement {
  constructor() {
    super();

    this.initSlide();
  }

  initSlide() {
    const desktopColumns = this.getAttribute('data-column');
    const mobileColumns = this.getAttribute('data-column-mobile');
    const slideArrows = document.querySelectorAll('.js-collections-slide-arrow');

    const slide = $(this).slick({
      slidesToShow: desktopColumns,
      arrows: false,
      slidesToScroll: 1,
      dots: true,
      responsive: [
        {
          breakpoint: 600,
          settings: {
            slidesToShow: mobileColumns,
            slidesToScroll: 1
          }
        },
        {
          breakpoint: 480,
          settings: {
            slidesToShow: mobileColumns,
            slidesToScroll: 1
          }
        }
      ]
    });

    $('.js-collections-slide-arrow').on('click', function(){
      const arrowType = $(this).attr('data-type');
      
      slide.slick(arrowType);
    })
  }
}

customElements.define('collections-slide', CollectionsSlide);